import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { interval } from 'rxjs';
import { Subscription } from 'rxjs/internal/Subscription';
import { ApiConstants } from 'src/app/core/constants/api-path.constants';
import { ApiService } from 'src/app/core/services/api.service';
import { ServiceLocalStorage } from 'src/app/core/services/local-storage.service';
import { NotificationService } from 'src/app/core/services/notification.service';
import { ServiceSharedData } from 'src/app/core/services/shared-data.service';

@Component({
  selector: 'app-vendor-trip-view',
  templateUrl: './vendor-trip-view.component.html',
  styleUrls: ['./vendor-trip-view.component.scss']
})
export class VendorTripViewComponent implements OnInit, OnDestroy {

  startTimer: boolean = false;
  tripViewFlag: boolean = false;
  headErrorFlag: boolean = false;
  errorList: any[] = [];
  tripList: any[] = [];
  cities: any[] = [];
  sites: any[] = [];
  sub: Subscription;
  selectedCityId: any;
  selectedCity: any = '';
  selectedSite: any = '';
  selectedShiftType: any;
  tripDate: any;
  generatedShift: any;
  headErrorMsg: any;
  shiftTypes: any[] = ["IN", "OUT", "ALL"];

  constructor(
    private readonly apiService: ApiService,
    private serviceSharedData: ServiceSharedData,
    private serviceLocalStorage: ServiceLocalStorage,
    private notifyService: NotificationService,
    private ngxLoader: NgxUiLoaderService,
    private router: Router
  ) { }

  ngOnInit() {
    setTimeout(() => {
      const sharedData = ServiceSharedData.TRIP_GENERATION;
      const data = {
        locationsList: this.serviceSharedData.getData(sharedData.locationsList),
        sitesList: this.serviceSharedData.getData(sharedData.sitesList),
        location: this.serviceSharedData.getData(sharedData.location),
        site: this.serviceSharedData.getData(sharedData.site),
        date: this.serviceSharedData.getData(sharedData.date),
        shiftType: this.serviceSharedData.getData(sharedData.shiftType),
        tripViewFlag: this.serviceSharedData.getData(sharedData.tripViewFlag),
        saveTripMirroringFlag: this.serviceSharedData.getData(sharedData.saveTripMirroringFlag)
      };
      if (Object.values(data).slice(0, -1).every(Boolean) && data.tripViewFlag) {
        Object.assign(this, {
          cities: data.locationsList,
          sites: data.sitesList,
          selectedCityId: data.location,
          selectedCity: data.location,
          selectedSite: data.site,
          tripDate: data.date,
          selectedShiftType: data.shiftType
        });
        if (data.saveTripMirroringFlag) {
          this.generatedShift = this.serviceSharedData.getData(sharedData.shiftId);
          this.startTimer = true;
          this.showTrips(true);
        } else {
          this.startTimer = false;
          this.showTrips(false);
        }
        this.serviceSharedData.setData(sharedData.tripViewFlag, false);
        this.serviceSharedData.setData(sharedData.saveTripMirroringFlag, false);
      } else {
        this.selectedShiftType = this.shiftTypes[2];
        this.tripDate = new Date();
        this.loadCities();
      }
      this.startInterval();
    }, 0);

  }

  ngOnDestroy() {
    this.stopInterval();
  }

  startInterval() {
    this.sub = interval(12000).subscribe(val => {
      if (this.startTimer) this.showTrips(true);
    });
  }

  stopInterval() {
    if (this.sub) {
      this.sub.unsubscribe();
    }
  }

  loadCities() {
    const companyId = +this.serviceLocalStorage.getCompanyId();
    this.apiService.doGetRequestWithResponse(ApiConstants.getLocationsByCompanyIdAndUser + companyId, success => {
      if (success.status == 200) {
        this.cities = success.body;
        if (this.cities.length > 0) {
          this.selectedCity = this.cities[0].locationId;
          this.getSitesByCityId({ target: { value: this.cities[0].locationId } });
        }
      } else {
        this.cities = [];
        this.notifyService.showInfo("No Location Found!", null)
      }
    }, error => {
      console.log(error)
    });
  }

  getSitesByCityId(cityId) {
    this.selectedCityId = cityId;
    this.apiService.doGetRequestWithResponse(ApiConstants.getserchsitelist + cityId.target.value, success => {
      if (success.status == 200) {
        this.sites = success.body;
        if (this.sites.length > 0) {
          this.selectedSite = this.sites[0].siteId;
        }
      } else {
        this.sites = [];
        this.notifyService.showInfo("No Site Found!", null)
      }
    }, error => {
      console.log(error)
    });
  }

  formatDate(d): any {
    let m = d.getMonth() + 1;
    let dt = d.getDate() < 10 ? "0" + d.getDate() : d.getDate();
    let mm = m < 10 ? "0" + m : m;
    return dt + "/" + mm + "/" + d.getFullYear();
  }

  showTrips(timer) {
    this.errorList = [];
    if (!this.tripDate || !this.selectedSite) {
      this.notifyService.showWarning("Site / Date is not selected", null);
      return;
    }

    !timer && this.ngxLoader.start();
    this.apiService.doGetRequestWithResponse(
      `${ApiConstants.tripstats}${this.formatDate(this.tripDate)}&siteid=${this.selectedSite}&logType=${this.selectedShiftType}`,
      success => {
        this.ngxLoader.stop();
        this.tripList = [];
        if (success.status === 200) {
          success.body.filter(Boolean).forEach(element => {
            if (!element.ERROR) {
              this.tripList.push({
                time: element.SHIFT,
                totalEmp: element.BOOKING,
                femaleEmp: element.FEMALE,
                totalTrips: element.TRIPS,
                totalAdhocEmp: element.ADHOCBOOKING,
                escortTrip: element.SECURITY,
                SHIFTID: element.SHIFTID,
                MSG: element.MSG,
                ERRORMSG: element.ERRORMSG
              });

              element.totalTrips > 0 && element.MSG === "" && (this.tripViewFlag = true);
              element.TRIPS > 0 && element.MSG === "" && element.SHIFTID === this.generatedShift && (this.startTimer = false);
            } else {
              this.errorList.push({
                ERROR: element.ERROR,
                SHIFTLOG: element.SHIFTLOG,
                SITENAME: element.SITENAME,
                TRIPDATE: element.TRIPDATE,
                ERROR1: element.ERROR1,
                ERROR2: element.ERROR2,
                ERROR3: element.ERROR3
              });
            }
          });
          this.getErrorHead();
        } else {
          this.notifyService.showInfo("No Data Found", null);
        }
      },
      error => {
        this.ngxLoader.stop();
        this.notifyService.showInfo(error.status === 500 ? "Please wait for a moment.." : "Please wait..", null);
        this.startTimer = true;
      }
    );
  }

  getErrorHead() {
    const firstTrip = this.tripList[0];
    if (firstTrip?.ERRORMSG) {
      this.headErrorMsg = firstTrip.ERRORMSG;
      this.headErrorFlag = true;
    }
  }

  viewDetailedTrip(shiftid) {
    const sharedData = ServiceSharedData.TRIP_GENERATION;
    const dataToSet = {
      locationsList: this.cities,
      sitesList: this.sites,
      location: this.selectedCityId,
      site: this.selectedSite,
      date: this.tripDate,
      shiftType: this.selectedShiftType
    };
    Object.entries(dataToSet).forEach(([key, value]) =>
      this.serviceSharedData.setData(sharedData[key], value)
    );
    this.router.navigate(["/myatom/routing/vendertripview", this.selectedSite, shiftid, this.formatDate(this.tripDate)]);
  }


  // generate(shift) {
  //   this.errorFlag = true;
  //   let tripData;
  //   if (this.tripDate) {
  //     tripData = {
  //       requestedDate: this.formatDate(this.tripDate),
  //       site: this.selectedSite,
  //       shift: shift
  //     };
  //     this.openDialog(tripData);
  //   } else {
  //     this.notifyService.showWarning("date/site is empty!", null);
  //   }
  // }

  // openDialog(data: any): void {
  //   let dialogRef = this.dialog.open(TripGenerationComponent, {
  //     width: "auto",
  //     data: data,
  //     disableClose: true
  //   });
  //   dialogRef.afterClosed().subscribe(result => {
  //     if (result) {
  //       if (result.status === 'onMirroringSubmit') {
  //         this.generatedShift = result.shiftId;
  //         this.serviceSharedData.setData(ServiceSharedData.TRIP_GENERATION.locationsList, this.cities);
  //         this.serviceSharedData.setData(ServiceSharedData.TRIP_GENERATION.sitesList, this.sites);
  //         this.serviceSharedData.setData(ServiceSharedData.TRIP_GENERATION.location, this.selectedCityId);
  //         this.serviceSharedData.setData(ServiceSharedData.TRIP_GENERATION.site, this.selectedSite);
  //         this.serviceSharedData.setData(ServiceSharedData.TRIP_GENERATION.date, this.tripDate);
  //         this.serviceSharedData.setData(ServiceSharedData.TRIP_GENERATION.shiftType, this.selectedShiftType);
  //         this.serviceSharedData.setData(ServiceSharedData.TRIP_GENERATION.shiftId, result.shiftId);
  //       } else {
  //         this.generatedShift = result.shiftId;
  //         this.startTimer = true;
  //         setTimeout(() => {
  //           this.showTrips(false);
  //         }, 5);
  //       }
  //     }
  //   });
  // }

}
